import { Turbo } from '@hotwired/turbo-rails'
import SlideOverController from './slide_over_controller'

const INTERACTIVE = 'a, button, input, select, label, [data-reflex], .dropdown'
const OPEN_OVERLAY = 'dialog[open], [data-slide-over-target="overlay"]:not(.hidden)'
const FIELD = 'input, textarea, select'
const REFRESH_DELAY = 1000

const SKELETON = `
  <div class="p-5 space-y-4 animate-pulse">
    <div class="flex items-center gap-3">
      <div class="w-11 h-11 rounded-xl bg-gray-200"></div>
      <div class="flex-1 space-y-2"><div class="h-4 w-1/2 rounded bg-gray-200"></div><div class="h-3 w-3/4 rounded bg-gray-100"></div></div>
    </div>
    <div class="h-16 rounded-xl bg-gray-100"></div>
    <div class="h-24 rounded-xl bg-gray-100"></div>
    <div class="h-40 rounded-xl bg-gray-100"></div>
  </div>`

export default class extends SlideOverController {
  static targets = ['overlay', 'aside', 'content']

  disconnect() {
    clearTimeout(this.refreshTimer)
  }

  open(event) {
    if (event.target.closest(INTERACTIVE)) return

    this.shown = { url: event.params.url, prospectIds: event.currentTarget.dataset.prospectIds?.split(' ') || [] }
    this.show()
    this.contentTarget.innerHTML = SKELETON
    this.load()
  }

  close() {
    super.close()
    this.shown = null
    this.panelStale = false
    if (this.pageStale) this.scheduleRefresh()
  }

  async load() {
    const shown = this.shown
    let html
    try {
      const response = await fetch(shown.url, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!response.ok) throw new Error(response.statusText)
      html = await response.text()
    } catch (e) {
      html = `<p class="p-6 text-sm text-red-600">Falha ao carregar o lead: ${e.message}</p>`
    }
    if (shown === this.shown) this.contentTarget.innerHTML = html
  }

  stageChanged({ detail }) {
    const ids = detail?.prospectIds || []
    if (ids.some((id) => this.element.querySelector(`[data-prospect-ids~="${id}"]`))) this.pageStale = true
    if (this.shown && ids.some((id) => this.shown.prospectIds.includes(id))) this.panelStale = true
    if (this.pageStale || this.panelStale) this.scheduleRefresh()
  }

  scheduleRefresh() {
    clearTimeout(this.refreshTimer)
    this.refreshTimer = setTimeout(() => this.refresh(), REFRESH_DELAY)
  }

  refresh() {
    if (this.panelStale && !this.contentTarget.querySelector('details[open]')) {
      this.panelStale = false
      this.load()
    }
    if (this.pageStale && !this.shown && !this.pageBusy()) {
      this.pageStale = false
      Turbo.visit(window.location.href, { action: 'replace', refresh: { method: 'morph', scroll: 'preserve' } })
    }
    if (this.panelStale || (this.pageStale && !this.shown)) this.scheduleRefresh()
  }

  pageBusy() {
    return document.querySelector(OPEN_OVERLAY) || document.activeElement?.matches(FIELD)
  }

  celebrate() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve()

    const colors = ['#FFDE45', '#FFD700', '#F59E0B', '#10B981', '#111827']
    const pieces = Array.from({ length: 80 }, (_, index) => {
      const piece = document.createElement('span')
      piece.style.cssText = `position:fixed;top:-12px;left:${Math.random() * 100}vw;width:8px;height:12px;z-index:2000;pointer-events:none;background:${colors[index % colors.length]};border-radius:2px`
      document.body.appendChild(piece)
      piece.animate(
        [{ transform: 'translateY(0) rotate(0deg)' }, { transform: `translateY(105vh) rotate(${Math.random() * 720}deg)` }],
        { duration: 1200 + Math.random() * 600, easing: 'cubic-bezier(.2,.6,.4,1)' },
      )
      return piece
    })
    return new Promise((resolve) => setTimeout(() => { pieces.forEach((piece) => piece.remove()); resolve() }, 1600))
  }

  async move(event) {
    event.preventDefault()
    const form = event.target
    const feedback = form.querySelector('[data-move-feedback]')
    const buttons = form.querySelectorAll('button[type=submit]')
    buttons.forEach((button) => (button.disabled = true))

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (response.ok) {
        buttons.forEach((button) => (button.textContent = 'Registrado'))
        if (form.elements.kind?.value === 'deal_closed') await this.celebrate()
        return window.location.reload()
      }

      const message = response.status === 403 ? 'Você não pode mover este lead.' : await response.text()
      if (feedback) feedback.textContent = message
    } catch (e) {
      if (feedback) feedback.textContent = `Não foi possível registrar: ${e.message}`
    }
    buttons.forEach((button) => (button.disabled = false))
  }
}
